import React from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { useEffect, useState } from 'react';

const Footer = () => {
  // const { pageTitle } = useParams();
  const [allPage, setAllPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: Adds smooth scrolling
    });
  };

  useEffect(() => {
    const fetchAllPage = async () => {
      try {
        const res = await fetch(`${config.baseUrl}/static-pages`);
        const data = await res.json();
        setAllPage(data.data);
      } catch (error) {
        console.error("Page not found", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllPage();
  }, []);
  return (
    <footer>
      <div className="footer-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-1">
              <div className="footer-logo">
                <img src="/images/footerlogo.png" alt="footer-logo" />
              </div>
            </div>

            <div className="col-md-11 footerright">
              <div className="footer-menu">
                <div className="row">
                  <div className="col-md-3">
                    <h5>Support</h5>
                    <ul>
                      <li>
                        <Link to="/contact-us">Contact</Link>
                      </li>
                      <li>
                        <Link to="/affiliates">Affiliates</Link>
                      </li>
                      {/* <li>
                        <Link to="#" onClick={scrollToTop}>Sitemap</Link>
                      </li> */}
                      <li>
                        <Link to="/cancellation-policy">
                          Cancellation Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/privacy">Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/disclamer">Legal Disclaimer</Link>
                      </li>
                      <li>
                        <Link to="/blogs">Blogs</Link>
                      </li>
                      <li>
                        <Link to="/faq">Faq</Link>
                      </li>
                      {/* <li>
                    <Link to="#">Glossary</Link>
                  </li>
                  <li>
                    <Link to="#">Cookie Settings</Link>
                  </li> */}
                    </ul>
                  </div>
                  <div className="col-md-3">
                    <h5>services</h5>
                    <ul>
                      <li>
                        <Link to="/services">Registered Agent</Link>
                      </li>
                      <li>
                        <Link to="/services">Annual Report</Link>
                      </li>
                      <li>
                        <Link to="/services">Certificate of Good Standing</Link>
                      </li>
                      <li>
                        <Link to="/services">Change Of Registered Agent</Link>
                      </li>
                      <li>
                        <Link to="/services">Amendment</Link>
                      </li>
                      {/*    <li>
                    <Link to="#">Dissolution</Link>
                  </li> */}
                      <li>
                        <Link to="/services">Get an EIN / TAX Number</Link>
                      </li>
                      <li>
                        <Link to="/services">Business License Search</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-3">
                    <h5>quick links</h5>
                    <ul>
                      {
                        allPage &&
                        allPage.map((page) => (
                          <li key={page.id}>
                            <Link to={`/${page?.slug}`} onClick={scrollToTop}>
                              {page.title}
                            </Link>
                          </li>
                        ))
                      }
                    </ul>
                  </div>
                  <div className="col-md-3">
                    <h5>get in touch</h5>
                    <h4>(804) 916-1974</h4>
                    <p>
                      Monday – Saturday: 8AM – 6PM
                      <br />
                      Sunday: OFF DAY
                    </p>
                    <div className="addresss">
                      <p>901 N Pitt Str., Suite 170 Alexandria, USA</p>
                    </div>
                    <div className="footer-socail">
                      <ul>
                        <li>
                          <Link
                            to="https://www.facebook.com/corpquick/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {" "}
                            <img src="/images/facebook.png" alt="facebook" />
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="https://www.instagram.com/corp.quick/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src="/images/instagram.png" alt="instagram" />
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="https://www.linkedin.com/company/corpquick"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src="/images/linkedin.png" alt="instagram" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copt-right">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-1"></div>
            <div className="col-md-11 copy">
              <p>
                © 2025 CorpQuick. All rights reserved. |{" "}
                <Link to="/privacy" style={{ color: "white" }}>
                  Privacy Policy
                </Link>{" "}
                |{" "}
                <Link to="/disclamer" style={{ color: "white" }}>
                  Legal Disclamer
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
